var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isModelActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 80,
        "min-height": 85,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isModelActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "p",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _c("span", [_vm._v("Booking")]),
          ]
        ),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c("div", { staticClass: "tabs is-toggle is-toggle-rounded" }, [
          _c("ul", [
            _c("li", { class: { "is-active": _vm.isBookingActive } }, [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.tabClicked(_vm.tabs[0])
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-calendar-month mdi-18px" }),
                  ]),
                  _c("span", [
                    _c("span", [_vm._v("Booking")]),
                    _c("span", {
                      staticClass: "has-badge-rounded has-badge-medium",
                      class: [false ? "has-badge-info" : "has-badge-dark"],
                    }),
                  ]),
                ]
              ),
            ]),
            _vm.isRepx
              ? _c("li", { class: { "is-active": _vm.isRepxActive } }, [
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.tabClicked(_vm.tabs[1])
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "icon is-small" }, [
                        _c("i", { staticClass: "mdi mdi-email-open mdi-18px" }),
                      ]),
                      _c("span", [
                        _c("span", [_vm._v("Repx")]),
                        _c("span", {
                          staticClass: "has-badge-rounded has-badge-medium",
                          class: [false ? "has-badge-info" : "has-badge-dark"],
                        }),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isBookingActive,
                expression: "isBookingActive",
              },
            ],
            staticClass: "quote-header tile is-ancestor is-parent",
          },
          [
            _vm.entity
              ? _c("booking-claim", {
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
            _vm.entity
              ? _c("booking-vehicle", {
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
            _vm.entity
              ? _c("booking-customer", {
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm.isRepxActive
          ? _c(
              "div",
              { staticClass: "quote-header is-ancestor is-parent" },
              [
                _c("repx-list", {
                  attrs: {
                    "hide-filter": true,
                    "quote-booking-id": _vm.innerBookingId,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "unsaved-modal",
        {
          attrs: { active: _vm.isUnsavedModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedModalActive = $event
            },
            close: function ($event) {
              return _vm.closeModal()
            },
            skipSave: function ($event) {
              return _vm.skipSave()
            },
            saveContinue: function ($event) {
              return _vm.saveContinue()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Unsaved Changes"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v("There are unsaved changes. Please select action below"),
          ]),
        ]
      ),
      _vm.entity
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.handleDelete()
                },
                cancel: function ($event) {
                  _vm.isConfirmModalActive = !_vm.isConfirmModalActive
                },
              },
              model: {
                value: _vm.entity,
                callback: function ($$v) {
                  _vm.entity = $$v
                },
                expression: "entity",
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Delete Booking"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(" Booking "),
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(`${_vm.entity.vehicleRegistrationNo}`))]
                  ),
                  _vm._v(" will be deleted. Continue? "),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "footer",
        { staticClass: "modal-card-foot is-flex is-justify-content-flex-end" },
        [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _vm.enableDelete
                ? _c(
                    "button",
                    {
                      staticClass: "button is-danger tooltip",
                      attrs: { "data-tooltip": "Delete" },
                      on: {
                        click: function ($event) {
                          _vm.isConfirmModalActive = !_vm.isConfirmModalActive
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-delete mdi-20px" }),
                      ]),
                      _c("span", [_vm._v("Delete")]),
                    ]
                  )
                : _vm._e(),
              _vm.enableConvert
                ? _c(
                    "button",
                    {
                      staticClass: "button is-warning tooltip",
                      attrs: { "data-tooltip": "Convert" },
                      on: { click: _vm.handleConvert },
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", {
                          staticClass: "mdi mdi-swap-horizontal mdi-20px",
                        }),
                      ]),
                      _c("span", [_vm._v("Convert")]),
                    ]
                  )
                : _vm._e(),
              _vm.enableSave
                ? _c(
                    "button",
                    {
                      staticClass: "button is-success tooltip",
                      attrs: { "data-tooltip": "Save" },
                      on: { click: _vm.handleSave },
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", {
                          staticClass: "mdi mdi-content-save mdi-20px",
                        }),
                      ]),
                      _c("span", [_vm._v("Save")]),
                    ]
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: {
                    "data-tooltip": _vm.isDeleted ? "Close" : "Cancel changes",
                  },
                  on: { click: _vm.handleCancel },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", {
                      staticClass: "mdi mdi-20px",
                      class: _vm.isDeleted
                        ? "mdi-close"
                        : "mdi-content-save-off",
                    }),
                  ]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.isDeleted ? "Close" : "Cancel")),
                  ]),
                ]
              ),
              _vm.isBookingConvertQuoteActive
                ? _c("booking-convert-to-quote", {
                    attrs: {
                      active: _vm.isBookingConvertQuoteActive,
                      "quote-booking-id": _vm.innerBookingId,
                      entity: _vm.entity,
                    },
                    on: {
                      "update:active": function ($event) {
                        _vm.isBookingConvertQuoteActive = $event
                      },
                      close: _vm.closeBookingConvertQuote,
                    },
                    model: {
                      value: _vm.loadOptions,
                      callback: function ($$v) {
                        _vm.loadOptions = $$v
                      },
                      expression: "loadOptions",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }